import React, { Component } from 'react'
import Button from '@material-ui/core/Button';

export class ScrapperHTML extends Component {

   Scrap=()=>{
    let Language2="";
    let PresentParticiple = "";
   let PastParticiple ="";
   let Present=[];
   let Past=[];
   let Past1=[];
   let Conditional=[];
   let Future=[];
   let Imperativ=[];
   let Imperativ1=[];
   let Present_Subjunctive=[];


   const cheerio = require('cheerio');
   const request = require('request');

//    var fs = require('fs');

// cheerio.load(fs.readFile('HtmlBook.html'));

   alert("scrape1");


   request({
       method: 'GET',
       //url: 'https://www.spanishdict.com/conjugate/'+this.props.SearchedWord
//<a href="file:///C:\Programs\sort.mw">Link 1</a>
url:"http://localhost:3000/htmlFrame"

     // url:"http://conjugator.reverso.net/conjugation-french-verb-" + this.props.SearchedWord + ".html"
   }, (err, res, body) => {
    console.log(body);
       if (err) return console.error(err);
       let $ = cheerio.load(body);
   

    //  $(".conj-basic-word").each(function (i, e) {
    //    if(i==0)
    //      PresentParticiple = $(this).text();
    //    if(i==1)
    //      PastParticiple= $(this).text();
    //  });

     var text="";
     console.log($);
     $('.myClass').each(function (i, e) {
      console.log($(this));
      alert("scrape2");
      if($(this).text() != undefined)
      {
      text += " ;; " + $(this).text();
      }

  });
  alert(text);

  //  $('.blue-box-wrap li').each(function (i, e) {

  //   if($(this).text() != undefined)
  //   {
  //   if(i==0)
  //   Present[0] = $(this).text();
  //   else if(i==1)      
  //   Present[1] = $(this).text();
  //   else if(i==2)      
  //   Present[2] = $(this).text();
  //   else if(i==3)      
  //   Present[3] = $(this).text();
  //   else if(i==4)      
  //   Present[4] = $(this).text();
  //   else if(i==5)
  //   Present[5] = $(this).text();

  
  // }

  //  });

   this.props.ScrapperCall(text);

  //this.props.ScrapperCall(Language2,PresentParticiple,PastParticiple,Present,Past,Past1,Conditional,Future,Imperativ,Imperativ1,Present_Subjunctive);
 
   });

 }



  render() {
    return (
      <div>
      <Button onClick={()=>this.Scrap()} variant="contained" color="secondary">
                        Scrap
                        </Button>
      </div>
    )
  }
}

export default ScrapperHTML




